import { FC, ReactNode } from "react";

interface props {
  disabled?: boolean;
  onClick: () => void;
  title: string;
  shape: ReactNode;
}

export const TileButton: FC<props> = (props) => {
  return (
    <button
      className="btn btn-block h-[167px] shadow-none bg-white rounded-xl disabled:opacity-25"
      disabled={props.disabled}
      onClick={!props.disabled ? props.onClick : undefined}
    >
      <div className="flex items-center justify-center flex-col w-full h-full">
        {props.shape}
        <div className="mt-4 text-[#555555]">{props.title}</div>
      </div>
    </button>
  );
};
